var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-wrapper",class:{'loderhide' : !_vm.show }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader bg-white"},[_c('div',{staticClass:"whirly-loader"})])
}]

export { render, staticRenderFns }